import { Routes, Route, Navigate } from 'react-router-dom';
import Page404 from "components/page404/PageNotFound";
import Home from "components/home/Home";
import Configuration from "components/configuration/Configuration";

const RoutesComponent = () => (
    <Routes>
        <Route path='/home' element={<Home />} />
        <Route path='/configuration' element={<Configuration />} />
        <Route path="*" element={<Navigate to="/home" />} />
    </Routes>
);

export default RoutesComponent;
